import React, { type ComponentPropsWithoutRef } from 'react';
import { portaledSurfaceVariants, type PortaledSurfaceVariant } from '../lib/portaledSurface';
import { cn } from '../lib/utils';
import { PopoverContent as PopoverContentContent } from './ui/popover';

type PopoverContentProps = ComponentPropsWithoutRef<typeof PopoverContentContent> & {
  /** Light (default) or dark surface. Pass `"dark"` for every popover opened from inside a `DarkThemeScope` — it portals to `document.body` and so escapes the scope's own `.dark`. */
  variant?: PortaledSurfaceVariant;
};

export const PopoverContent: React.FC<PopoverContentProps> = ({
  variant = 'light',
  className,
  ...props
}) => {
  return (
    <PopoverContentContent
      {...props}
      className={cn(
        'tw max-h-[var(--radix-popper-available-height)] border-border-muted',
        portaledSurfaceVariants({ variant }),
        className,
      )}
    />
  );
};

export { Popover, PopoverAnchor, PopoverTrigger } from './ui/popover';
